import React from 'react';
import { Product, Rating } from 'types/Product';
import Show from 'components/Functional/Show';
import { PriceObject } from '../ProductDetails/ProductPrice';
import { PDPMetatags } from '../ProductDetails/PDPMetaTags';
import YotpoStars from 'components/Yotpo/YotpoStars';
import { isNotServerSideRendering } from 'helpers/env';
import { formatPrice } from 'helpers/currency';
import {
  ProductHeaderContainer,
  ProductPromoTitle,
  PricingPromoContainer,
  OriginalPrice,
  StrikethroughPrice,
  ValuePropText
} from './styled';
import { PromoCode } from 'components/Strikethrough';

type ProductHeaderProps = {
  product: Product;
  productTitle: string;
  price: PriceObject;
  siteUrl: string;
  rating: Rating;
};

const ProductHeader = ({ product, productTitle, price, siteUrl, rating }: ProductHeaderProps): JSX.Element => {
  const isNotSSR = isNotServerSideRendering();

  const shouldDisplayPromoCode = price.promoCode?.length > 0;

  const valueProp = product.valueProposition;

  return (
    <ProductHeaderContainer>
      <PDPMetatags product={product} siteUrl={siteUrl || ''} />

      {rating && <YotpoStars rating={rating} />}

      <ProductPromoTitle data-testid="product-title">{productTitle}</ProductPromoTitle>

      <PricingPromoContainer strikethrough={!!price.strikethroughPrice}>
        {/* Initial price from SSR may be different from actual price due to product options, */}
        {/* so we can't display price until CSR kicks in */}
        <Show when={isNotSSR}>
          <Show when={!!price.strikethroughPrice}>
            <StrikethroughPrice>
              From {formatPrice(price.strikethroughPrice)}
            </StrikethroughPrice>
          </Show>

          <OriginalPrice>
            {!price.strikethroughPrice && 'From'} {formatPrice(price.productPriceTotal)}
          </OriginalPrice>
        </Show>

        {shouldDisplayPromoCode && <PromoCode code={price.promoCode} />}
      </PricingPromoContainer>

      {valueProp && <ValuePropText>{valueProp}</ValuePropText>}
    </ProductHeaderContainer>
  );
};

export default ProductHeader;
